import { useState, Fragment } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { NotificationManager } from "react-notifications";
import { Form, Button, ButtonToolbar, Schema } from "rsuite";
import axios from "axios";
import "rsuite/dist/rsuite.min.css";
import "./reset-password.styles.scss";
const TextField = ({ name, label, accepter, ...rest }) => (
  <Form.Group controlId={name}>
    <Form.ControlLabel>{label} </Form.ControlLabel>
    <Form.Control name={name} accepter={accepter} {...rest} />
  </Form.Group>
);
const { StringType } = Schema.Types;
const resetPasswordModel = Schema.Model({
  token: StringType().isRequired("Please provide a valid token."),
  password: StringType().isRequired("This field is required."),
  confirm_password: StringType()
    .addRule((value, data) => {
      if (value !== data.password) {
        return false;
      }

      return true;
    }, "The two passwords do not match")
    .isRequired("This field is required."),
});
const ResetPassword = () => {
  const { token } = useParams();
  const [formValue, setFormValue] = useState({
    token: token,
    password: "",
    confirm_password: "",
  });
  const navigate = useNavigate();
  const handleResetSubmit = async (data) => {
    axios
      .post(API_URL.RESET_PASSWORD, {
        token: data.token,
        password: data.password,
      })
      .then((res) => {
        if (res.data.code === 200) {
          NotificationManager.success(res.data.msg, "Successful!", 2000);
          setFormValue({
            token: token,
            password: "",
            confirm_password: "",
          });
          navigate("/");
        } else {
          NotificationManager.error(res.data.msg, "Error!");
        }
      })
      .catch((err) => {
        NotificationManager.error("Error while reset password!", "Error!");
      });
  };

  return (
    <Fragment>
      <section className="bgc-f7 header-padding">
        <Container>
          <Row className="justify-content-md-center">
            <Col md="4">
              <div className="reset-form-wrapper">
                <Form
                  model={resetPasswordModel}
                  fluid
                  onChange={setFormValue}
                  formValue={formValue}
                  onSubmit={() => handleResetSubmit(formValue)}
                >
                  <h3>Set New Password</h3>
                  <TextField name="password" label="Password" type="password" />
                  <TextField
                    name="confirm_password"
                    label="Confirm Password"
                    type="password"
                  />

                  <ButtonToolbar>
                    <Button
                      appearance="default"
                      className="btn-thm w-100"
                      type="submit"
                      disabled={
                        !formValue.password && !formValue.confirm_password
                      }
                    >
                      Change
                    </Button>
                  </ButtonToolbar>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Fragment>
  );
};

export default ResetPassword;
